__turbopack_context__.v({
  "active": "I8JDgq_active",
  "articleItem": "I8JDgq_articleItem",
  "articleList": "I8JDgq_articleList",
  "backButton": "I8JDgq_backButton",
  "categoryContent": "I8JDgq_categoryContent",
  "categoryHeader": "I8JDgq_categoryHeader",
  "categoryTitle": "I8JDgq_categoryTitle",
  "categoryTree": "I8JDgq_categoryTree",
  "categoryWrapper": "I8JDgq_categoryWrapper",
  "chevron": "I8JDgq_chevron",
  "expanded": "I8JDgq_expanded",
  "hasActive": "I8JDgq_hasActive",
  "header": "I8JDgq_header",
  "item": "I8JDgq_item",
  "link": "I8JDgq_link",
  "list": "I8JDgq_list",
  "menu": "I8JDgq_menu",
  "text": "I8JDgq_text",
  "title": "I8JDgq_title",
});
